import { Skeleton } from '@monksflow/monks-ui';

import { LoadingRegion } from '@/shared/ui/skeletons';

const BRAND_ROWS = Array.from({ length: 3 });
const SECTION_ROWS = Array.from({ length: 3 });

/** The brand list beside the open brand's editor, as `ReelBrandKit` lays them out once loaded. */
export const ReelBrandKitSkeleton = () => {
  return (
    <LoadingRegion
      data-testid="reel-brand-kit-skeleton"
      className="flex min-h-0 flex-1 flex-col md:flex-row"
    >
      <div className="flex shrink-0 flex-col gap-sm border-b border-border-light p-md md:w-72 md:border-r md:border-b-0">
        <Skeleton className="h-8 w-1/2" />
        {BRAND_ROWS.map((_, index) => (
          <Skeleton key={index} className="h-14 w-full" />
        ))}
      </div>
      <div className="flex min-h-0 flex-1 flex-col gap-md p-lg">
        <Skeleton className="h-8 w-1/3" />
        <Skeleton className="h-9 w-96 max-w-full" />
        {SECTION_ROWS.map((_, index) => (
          <Skeleton key={index} className="h-16 w-full" />
        ))}
      </div>
    </LoadingRegion>
  );
};
